import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { APP_ROUTING } from './app-routing.module'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainComponent } from './components/main/main.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmarComponent } from './components/confirmar-dialog/confirmar.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppConfiguration } from './services/app-configuration.service';
import { LoginService } from './services/login.service';
import { AfiliadoService } from './services/afiliado.service';
import { EstudioService } from './services/estudio.service';
import { ServiceBase } from './services/base.service';
import { OrderService } from './services/order.service';
import { PrestadorService } from './services/prestador.service';
import { AuthService } from './services/auth.service';
import { Data } from './providers/data';
import {AuthGuardService} from './services/auth-guard.service';
import {RoleGuardService} from './services/role-guard.service';
import {Utils} from './providers/utils';
import {RoutingParams} from './services/routing-params.service';
import { QuicklinkModule } from 'ngx-quicklink';
import { MensajeComponent } from './components/mensaje/mensaje.component';
import { MaterialModule } from './material-module';
import { UserService } from './services/user.service';
@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    MensajeComponent,
    ConfirmarComponent
  ],
  imports: [
    QuicklinkModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    //QuicklinkModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    APP_ROUTING,
    MaterialModule
  ],
  providers: [
    Utils,
    ServiceBase,
    LoginService,
    EstudioService,
    AuthService,
    Data,
    RoutingParams,
    AuthGuardService,
    RoleGuardService,
    AfiliadoService,
    PrestadorService,
    UserService,
    OrderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServiceBase,
      multi: true
    },
    AppConfiguration,
    {
        provide: APP_INITIALIZER,
        useFactory: AppConfigurationFactory,
        deps: [AppConfiguration, HttpClient], multi: true },

  ],
  bootstrap: [AppComponent],
  entryComponents: [
    MensajeComponent,
  ]
})
export class AppModule { }
export function AppConfigurationFactory(appConfig: AppConfiguration) {
  return () => appConfig.ensureInit();
}
